import { useState, useCallback } from 'react';
import { EventStatusEnum } from '../../types/eventTypes';
import { CorporateEventStatusEnum } from '../../constants/enums';

export interface UseEventStatusManagementReturn {
  isDeclineModalOpen: boolean;
  isApproveModalOpen: boolean;
  radioGroupValue: string;
  otherValue: string;
  openDeclineModal: () => void;
  openApproveModal: () => void;
  closeDeclineModal: () => void;
  closeApproveModal: () => void;
  handleStatusChange: (status: EventStatusEnum | CorporateEventStatusEnum) => void;
  setRadioGroupValue: (value: string) => void;
  setOtherValue: (value: string) => void;
  handleRadioGroupChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleOtherChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const useEventStatusManagement = (): UseEventStatusManagementReturn => {
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState<boolean>(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState<boolean>(false);
  const [radioGroupValue, setRadioGroupValue] = useState<string>('');
  const [otherValue, setOtherValue] = useState<string>('');

  const openDeclineModal = useCallback(() => {
    setIsDeclineModalOpen(true);
  }, []);

  const closeDeclineModal = useCallback(() => {
    setIsDeclineModalOpen(false);
    setRadioGroupValue('');
    setOtherValue('');
  }, []);

  const openApproveModal = useCallback(() => {
    setIsApproveModalOpen(true);
  }, []);

  const closeApproveModal = useCallback(() => {
    setIsApproveModalOpen(false);
  }, []);

  const handleStatusChange = useCallback(
    (status: EventStatusEnum | CorporateEventStatusEnum) => {
      if (status === EventStatusEnum.Active) {
        // Reactivate - handled directly in component
        return;
      } else if (status === EventStatusEnum.Accepted) {
        openApproveModal();
      } else if (status === EventStatusEnum.Cancelled || status === CorporateEventStatusEnum.Cancelled) {
        openDeclineModal();
      }
    },
    [openApproveModal, openDeclineModal]
  );

  const handleRadioGroupChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioGroupValue(event.target.value);
  }, []);

  const handleOtherChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setOtherValue(event.target.value);
  }, []);

  return {
    isDeclineModalOpen,
    isApproveModalOpen,
    radioGroupValue,
    otherValue,
    openDeclineModal,
    openApproveModal,
    closeDeclineModal,
    closeApproveModal,
    handleStatusChange,
    setRadioGroupValue,
    setOtherValue,
    handleRadioGroupChange,
    handleOtherChange,
  };
};
